"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwLabel = _interopRequireDefault(require("../cwlabel/CwLabel"));

var _CwButton = _interopRequireDefault(require("../cwbutton/CwButton"));

var _CwPagination = _interopRequireDefault(require("./CwPagination.scss"));

var CwPagination = function CwPagination(props) {
  var resultStartIndex = 0;
  var resultEndIndex = 0;
  var previousPageButtonDisabled = true;
  var nextPageButtonDisabled = true;
  var totalResults = parseInt(props.totalResultCount, 10) || 0;

  if (totalResults > 0) {
    var magicMath = (props.resultsPage - 1) * props.resultsPerPage;
    resultEndIndex = magicMath + props.curResultsLength;

    if (resultEndIndex > totalResults) {
      // Cap the upper bound to total results when on the last page
      resultEndIndex = totalResults;
    }

    resultStartIndex = magicMath + 1;
    previousPageButtonDisabled = props.resultsPage === 1;
    /* Must be greater than or equal check because the button never gets
    disabled when the user clicks the button faster than this component updates. */

    nextPageButtonDisabled = resultEndIndex >= totalResults;
  }

  return _react.default.createElement("div", {
    className: props.className,
    style: props.style
  }, _react.default.createElement("div", {
    "data-cwid": "".concat(props.cwId, "_pagination_container"),
    className: _CwPagination.default.paginationContainer
  }, _react.default.createElement(_CwButton.default, {
    cwId: "".concat(props.cwId, "_button_previous_page"),
    className: _CwPagination.default.button,
    icon: props.backButtonIcon,
    disabled: previousPageButtonDisabled,
    onClick: props.onBackClick
  }), totalResults > 0 && _react.default.createElement("div", {
    className: _CwPagination.default.resultsCountContainer
  }, _react.default.createElement(_CwLabel.default, {
    cwId: "".concat(props.cwId, "_results_start"),
    value: resultStartIndex.toString()
  }), ' - ', _react.default.createElement(_CwLabel.default, {
    cwId: "".concat(props.cwId, "_results_end"),
    value: resultEndIndex.toString()
  }), ' of ', _react.default.createElement(_CwLabel.default, {
    cwId: "".concat(props.cwId, "_results_total"),
    value: totalResults.toString()
  })), totalResults === 0 && _react.default.createElement("div", {
    className: _CwPagination.default.resultsCountContainer
  }, _react.default.createElement(_CwLabel.default, {
    cwId: "".concat(props.cwId, "_results_start"),
    value: resultStartIndex.toString()
  }), ' of ', _react.default.createElement(_CwLabel.default, {
    cwId: "".concat(props.cwId, "_results_total"),
    value: totalResults.toString()
  })), _react.default.createElement(_CwButton.default, {
    cwId: "".concat(props.cwId, "_button_next_page"),
    className: _CwPagination.default.button,
    icon: props.nextButtonIcon,
    disabled: nextPageButtonDisabled,
    onClick: props.onNextClick
  })));
};

CwPagination.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes.default.string,

  /**
   * Override the styles of the root element
   */
  style: _propTypes.default.object,

  /**
   * Icon used for back button
   */
  backButtonIcon: _propTypes.default.string.isRequired,

  /**
   * Icon used for next button
   */
  nextButtonIcon: _propTypes.default.string.isRequired,

  /**
   * Number if items displayed in the list
   */
  curResultsLength: _propTypes.default.number.isRequired,

  /**
   * Current page number (starts at 1)
   */
  resultsPage: _propTypes.default.number.isRequired,

  /**
   * Number if items per page
   */
  resultsPerPage: _propTypes.default.number.isRequired,

  /**
   * Total number of items
   */
  totalResultCount: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,

  /**
   * Callback fired when next button is clicked
   */
  onNextClick: _propTypes.default.func.isRequired,

  /**
   * Callback fired when back button is clicked
   */
  onBackClick: _propTypes.default.func.isRequired
};
CwPagination.defaultProps = {
  cwId: '',
  className: '',
  style: {}
};
var _default = CwPagination;
exports.default = _default;